import EditColumnsModal from './EditColumnsModal';

export default EditColumnsModal;
